<template>
    <div class="basicDetails">
        <div class="rowInputs">
            <div class="form-group">
                <i class="fa-solid fa-globe"></i>
                <label>SiteWeb:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.siteWeb">
                </div>
            </div>
            <div class="form-group">
                <i class="fa-brands fa-twitter"></i>
                <label>Twitter:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.twitter">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <i class="fa-brands fa-facebook-f"></i>
                <label>Facebook:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.facebook">
                </div>
            </div>
            <div class="form-group">
                <i class="fa-brands fa-instagram"></i>
                <label>Instagram:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.instagram">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <i class="fa-brands fa-reddit"></i>
                <label>Reddit:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.reddit">
                </div>
            </div>
            <div class="form-group">
                <i class="fa-brands fa-tumblr"></i>
                <label>Tumblr:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.tumblr">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <i class="fa-brands fa-youtube"></i>
                <label>Youtube:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.youtube">
                </div>
            </div>
            <div class="form-group">
                <i class="fa-brands fa-linkedin-in"></i>
                <label>Linkdin:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.linkdin">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <i class="fa-brands fa-whatsapp"></i>
                <label>Whathsapp:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.whathsapp" placeholder="Entrez votre numero de téléphone">
                </div>
            </div>
            <div class="form-group">
                <i class="fa-brands fa-pinterest"></i>
                <label>Pinterest:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.pinterest">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <i class="fa-brands fa-tiktok"></i>
                <label>Tiktok:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.tiktok">
                </div>
            </div>
            <div class="form-group">
                <i class="fa-brands fa-telegram"></i>
                <label>Telegram:</label>
                <div>
                    <input type="text" class="form-control" v-model="socialMedia.telegram">
                </div>
            </div>
        </div>

        <button type="submit" class="btn btn-light me-2" @click="updateSociaxLinkData">Save</button>
    </div>
</template>

<script>
    import axios from 'axios'
    import APIs from './../../../../config'
    export default {
        data(){
            return {
                socialMedia: {
                    siteWeb: "",
                    twitter: "",
                    facebook: "",
                    instagram: "",
                    reddit: "",
                    tumblr: "",
                    youtube: "",
                    linkdin: "",
                    whathsapp: "",
                    pinterest: "",
                    tiktok: "",
                    telegram: ""
                },
                get_token: localStorage.getItem('token'),
                user_id: localStorage.getItem('user_id'),
            }
        },
        props : {
            cardInfo : Object
        },
        created() {
            console.log("sociaux link: ", this.cardInfo._id)
            this.getCurrentData()
        },
        methods: {
            getCurrentData() {
                this.socialMedia = this.cardInfo.socialMedia
            },
            updateSociaxLinkData() {
                let formData = {
                    socialMedia: this.socialMedia
                }

                axios.put(`${APIs.API_URL}/card/cardData/${this.user_id}/${this.cardInfo._id}`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                })
                .then(() => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Edited",
                        showConfirmButton: false,
                        timer: 1500
                    });
                })
                .catch(error => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: error.response.data.error,
                        showConfirmButton: false,
                        timer: 1500
                    });
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .basicDetails {
        background-color: white;
        padding: 2% 6%;
        border-radius: 10px;
        margin: 0% 5%;
        .rowInputs {
            display: flex;
            justify-content: space-around;
            .form-group {
                width: 45%;
            }
            .cardIcons {
                display: flex;
                justify-content: space-between;
                .cardIcon {
                    width: 45%;
                }
            }
        }
    }
</style>
